"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function ToggleUIButton({ onClick, hidden, className }, ref) {
    return ((0, jsx_runtime_1.jsx)(Container, { ref: ref, className: className, onClick: onClick, "data-e2e": 'ToggleUIButton_Container', children: (0, jsx_runtime_1.jsx)(StyledIcon, { name: hidden ? ui_1.Icons.Fullscreen_Exit : ui_1.Icons.Fullscreen_Enter, "data-e2e": 'ToggleUIButton_StyledIcon' }) }));
}
exports.default = (0, react_1.forwardRef)(ToggleUIButton);
const Container = (0, styled_components_1.default)(ui_1.BaseButton) `
  display: flex;
  align-items: center;

  width: 30px;
  height: 30px;

  margin: 0;
  padding: 0;

  background: ${props => props.theme.tools.fullscreenButton.background};

  border-radius: 2px;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 24px;
  height: 24px;

  margin: auto;

  color: ${props => props.theme.gray};
`;
